// Pure helpers for drag-and-drop file upload on the staff Documents tab.

/** True only when the drag carries files (not text, links or in-page drags). */
export function isFileDrag(
  types: ArrayLike<string> | readonly string[] | null | undefined,
): boolean {
  if (!types) return false;
  for (let i = 0; i < types.length; i++) {
    if (types[i] === "Files") return true;
  }
  return false;
}

export function filesFromList(list: ArrayLike<File> | null | undefined): File[] {
  if (!list) return [];
  const out: File[] = [];
  for (let i = 0; i < list.length; i++) out.push(list[i]);
  return out;
}

export interface UploadFailure { name: string; message?: string }

export function summarizeUploads(
  okNames: string[],
  failures: UploadFailure[],
): { title: string; description: string; destructive: boolean } {
  const failText = failures
    .map((f) => (f.message ? `${f.name} (${f.message})` : f.name))
    .join(", ");
  if (failures.length === 0) {
    return okNames.length === 1
      ? { title: "Uploaded", description: okNames[0], destructive: false }
      : { title: `Uploaded ${okNames.length} files`, description: okNames.join(", "), destructive: false };
  }
  if (okNames.length === 0) {
    return { title: "Upload failed", description: failText, destructive: true };
  }
  return {
    title: `Uploaded ${okNames.length} file${okNames.length === 1 ? "" : "s"}, ${failures.length} failed`,
    description: `Failed: ${failText}`,
    destructive: true,
  };
}
